import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Database, RefreshCw, AlertTriangle } from "lucide-react";
import { formatNumber } from "@/lib/formatters";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DataStatusCard = () => {
  const [data, setData] = useState(null);
  const [laster, setLaster] = useState(false);

  const hent = useCallback(async () => {
    setLaster(true);
    try {
      const res = await axios.get(`${API}/admin/data-status`, { withCredentials: true });
      setData(res.data);
    } catch {
      setData(null);
    }
    setLaster(false);
  }, []);

  useEffect(() => {
    hent();
  }, [hent]);

  const bak = (data?.tabellar || []).filter((t) => t.bak);

  return (
    <Card className="bg-white border border-[#E6E9F0] rounded-lg mb-8" data-testid="data-status-card">
      <CardHeader className="border-b border-[#E6E9F0] pb-4 flex flex-row items-start justify-between gap-4">
        <div>
          <CardTitle className="text-lg font-medium text-[#1F2A36] flex items-center gap-2">
            <Database className="w-5 h-5 text-[#103766]" />
            Kva år har tabellane data for?
          </CardTitle>
          <p className="text-sm text-[#4B647F]">
            Nyaste år i databasen: <span className="font-semibold text-[#1F2A36]">{data?.nyaste_aar || "—"}</span>
            {bak.length > 0 ? ` · ${bak.length} tabell${bak.length === 1 ? "" : "ar"} ligg meir enn to år bak` : " · ingen tabellar har hengt seg opp"}
          </p>
        </div>
        <Button variant="outline" size="sm" onClick={hent} disabled={laster} data-testid="data-status-refresh" className="border-[#E6E9F0] text-[#4B647F]">
          <RefreshCw className={`w-4 h-4 mr-2 ${laster ? "animate-spin" : ""}`} />
          Oppdater lista
        </Button>
      </CardHeader>
      <CardContent className="pt-6 overflow-x-auto">
        <table className="w-full text-xs" data-testid="data-status-table">
          <thead>
            <tr className="border-b border-[#E6E9F0] text-[#4B647F]">
              <th className="py-2 pr-3 text-left font-medium">Tabell</th>
              <th className="py-2 px-3 text-right font-medium">Rader</th>
              <th className="py-2 px-3 text-right font-medium">Siste år</th>
              <th className="py-2 pl-3 text-right font-medium">Sist oppdatert</th>
            </tr>
          </thead>
          <tbody>
            {(data?.tabellar || []).map((t) => (
              <tr key={t.tabell} className={`border-b border-[#F1F4F8] ${t.bak ? "bg-[#FDF3F2]" : ""}`} data-testid={`data-status-row-${t.tabell}`}>
                <td className="py-2 pr-3 text-[#1F2A36] flex items-center gap-1.5">
                  {t.bak && <AlertTriangle className="w-3.5 h-3.5 text-[#C0392B]" />}
                  {t.tabell}
                </td>
                <td className="py-2 px-3 text-right tabular-nums text-[#4B647F]">{formatNumber(t.rader)}</td>
                <td className={`py-2 px-3 text-right tabular-nums ${t.bak ? "text-[#C0392B] font-semibold" : "text-[#1F2A36]"}`}>
                  {t.siste_aar || "—"}
                  {t.framskriving && <span className="text-[#8AA4BF]"> (framskriving)</span>}
                </td>
                <td className="py-2 pl-3 text-right text-[#8AA4BF]">
                  {t.oppdatert ? new Date(t.oppdatert).toLocaleDateString("nb-NO") : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="text-xs text-[#8AA4BF] mt-3">
          Tabellar som er markerte raudt har data som er meir enn to år bak dagens år – då har truleg noko hengt seg opp, for SSB publiserer dei
          seinaste tabellane (til dømes inntekt) med om lag to års forseinking. Framskrivingar (år fram i tid) blir haldne utanfor. «Full
          oppdatering» hentar alle tabellar på nytt, også nye år, og skriv over dei gamle radene.
        </p>
      </CardContent>
    </Card>
  );
};

export default DataStatusCard;
